//个案管理 任务提醒 接口

//引入接口文档
import req from '@/utils/req.js'


//用户协议列表查询
export function api_list(params) {
    return req.get("/admin/user-agreement", params);
}
//用户协议更新
export function api_update(params) {
    return req.put("/admin/user-agreement", params);
}
//用户协议更新
export function api_detail(id) {
    return req.get(`"/admin/user-agreement/${id}`);
}

//平台医院列表查询
export function getHospitalList(params) {
  return req.post("/admin/platform/list", params);
}

//用户协议添加
export function add_api_detail(params) {
  return req.post("/admin/user-agreement", params);
}

//获取协议类型枚举
export function api_UserAgreementTypeEnum(params) {
  return req.get("/admin/enums/com.dsicm.data.metadata.enums.UserAgreementTypeEnum",params);
}
